<dt-modal-content (closeClick)="close(false)" [contentPadding]="false" [flexContent]="true">
  <ng-template #title i18n>Projekt erstellen</ng-template>
  <ng-template #content>
    <form [formGroup]="projectForm" (ngSubmit)="createProject()" class="dt-form">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Projektname</mat-label>
        <input
          i18n-placeholder
          placeholder="Unbenanntes Projekt"
          matInput
          type="text"
          formControlName="name"
          data-cy="project-name-input"
        />
      </mat-form-field>

      <mat-divider></mat-divider>

      <div class="mode-selection" formGroupName="mode">
        <div class="header" i18n>Mit welchem Level an Unterstützung willst Du starten?</div>

        <div
          class="entry"
          matRipple
          [class.active]="projectForm.value.mode === 'starter'"
          (click)="projectForm.patchValue({ mode: 'starter' })"
          data-cy="starter-mode-button"
        >
          <mat-radio-button name="mode-selection" [checked]="projectForm.value.mode === 'starter'"></mat-radio-button>
          <div>
            <span class="bold" i18n>Starter: </span>
            <ng-container i18n
              >Der Funktionsumfang ist bei dieser Variante eingeschränkt und somit zum ersten Einstieg in ein reflektiertes Entscheiden
              geeignet.</ng-container
            >
          </div>
        </div>

        <div
          class="entry"
          matRipple
          [class.active]="projectForm.value.mode === 'educational'"
          (click)="projectForm.patchValue({ mode: 'educational' })"
        >
          <mat-radio-button name="mode-selection" [checked]="projectForm.value.mode === 'educational'"></mat-radio-button>
          <div>
            <span class="bold" i18n>Educational: </span>
            <ng-container i18n
              >Du lernst detailliert mit vielen Teilschritten und inhaltlichen Erläuterungen, was einen reflektierten Entscheidungsprozess
              ausmacht, und trainierst somit Deine Entscheidungskompetenz.</ng-container
            >
          </div>
        </div>

        <div
          class="entry"
          matRipple
          [class.active]="projectForm.value.mode === 'professional'"
          (click)="projectForm.patchValue({ mode: 'professional' })"
          data-cy="mode-selection-professional"
        >
          <mat-radio-button name="mode-selection" [checked]="projectForm.value.mode === 'professional'"></mat-radio-button>
          <div>
            <span class="bold" i18n>Professional: </span>
            <ng-container i18n
              >Du analysierst eigenständig Dein Entscheidungsproblem mit dem vollen Funktionsumfang des Entscheidungsnavis.</ng-container
            >
          </div>
        </div>
      </div>

      <div class="team-container">
        <mat-slide-toggle
          formControlName="teamProject"
          i18n-matTooltip
          matTooltip="Nur für angemeldete Nutzer und in der Educational oder Professional Variante"
          [matTooltipDisabled]="projectForm.controls.teamProject.enabled"
        >
          <div class="toggle-text">
            <span class="prefix" i18n>Als Teamprojekt anlegen:</span>
            <span i18n
              >Du kannst weitere Personen zum gemeinsamen Lösen eines Entscheidungsproblems einladen und fungierst als Moderator.</span
            >
          </div>
        </mat-slide-toggle>
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <button
      mat-raised-button
      color="accent"
      [disabled]="projectForm.invalid || projectForm.disabled"
      [dtOverlayProgress]="projectForm.disabled"
      (click)="createProject()"
      data-cy="create-project-button"
      i18n
      >Projekt erstellen</button
    >
  </ng-template>
</dt-modal-content>
